import store from '..';
import {
  getDocumentsToStoreState,
  getDocuSignSignerRoleManagementState,
  getUserManagementState,
  getDocuSignTemplateManagementState,
  getOrganisationManagementState,
  getGroupedTableState,
  getAppSettingsState,
  getArenaSignTemplateManagementState,
  getArenaSignSignerRoleManagementState,
  getListMaintenanceState
} from './defaults';
import { StickySettingsMutationTypes } from '@/types';
import { StickySettingsActions, StickySettingsGetters, StickyStoreNames } from '@/types/constants';

const namespaced: boolean = true;

export const StickySettingsStore = {
  actions() {
    return {
      [StickySettingsActions.ResetStickyState]({ commit }: any) {
        commit(StickySettingsMutationTypes.ResetStickyState);
      },
      [StickySettingsActions.SetStickyStateField]({ commit }: any, stateField: any) {
        commit(StickySettingsMutationTypes.SetStickyStateField, stateField);
      }
    };
  },
  getters<T>() {
    return {
      [StickySettingsGetters.GetStickyStateField]: (state: T) => (field: keyof T): any => {
        if (!field.toString().contains('.')) {
          return state[field];
        }

        const propArray = field.toString().split('.');
        let stateObject = state as any;
        propArray.forEach((propName) => {
          stateObject = stateObject[propName];
        });

        return stateObject;
      }
    };
  },
  mutations<T>(getDefaultState: () => any) {
    return {
      [StickySettingsMutationTypes.ResetStickyState](state: T) {
        // Object.assign(state, defaultState);
        Object.assign(state, getDefaultState());
      },
      [StickySettingsMutationTypes.SetStickyStateField](state: T, stateField: any) {
        if (!stateField.field.includes('.')) {
          Object.assign(state, {
            [stateField.field]: stateField.value
          });
        } else {
          const propertyArray = stateField.field.split('.');
          const len = propertyArray.length;
          propertyArray.reduce((childObject: any, currentProperty: any, index: any) => {
            if (!childObject[currentProperty]) {
              childObject[currentProperty] = {};
            }
            if (index === len - 1) {
              childObject[currentProperty] = stateField.value;
            }
            return childObject[currentProperty];
          }, state);
        }
      }
    };
  },
  getStore<T>(defaultState: T, getDefaultState: () => any) {
    return {
      namespaced,
      state: { ...defaultState },
      actions: StickySettingsStore.actions(),
      getters: StickySettingsStore.getters(),
      mutations: StickySettingsStore.mutations(getDefaultState)
    };
  },
  registerStore<T>(moduleName: string, getDefaultState: () => any) {
    const vueXStore = store.state as any;
    if (!vueXStore[moduleName]) {
      store.registerModule(moduleName, StickySettingsStore.getStore(getDefaultState(), getDefaultState));
    }
  },
  registerStores() {
    StickySettingsStore.registerStore(StickyStoreNames.AppSettings, getAppSettingsState);
    StickySettingsStore.registerStore(StickyStoreNames.UserManagement, getUserManagementState);
    StickySettingsStore.registerStore(StickyStoreNames.OrganisationManagement, getOrganisationManagementState);
    StickySettingsStore.registerStore(StickyStoreNames.DocuSignTemplateManagement, getDocuSignTemplateManagementState);
    StickySettingsStore.registerStore(StickyStoreNames.DocuSignSignerRoleManagement, getDocuSignSignerRoleManagementState);
    StickySettingsStore.registerStore(StickyStoreNames.DocumentsToStore, getDocumentsToStoreState);
    StickySettingsStore.registerStore(StickyStoreNames.MStoreGroupedTable, getGroupedTableState);
    StickySettingsStore.registerStore(StickyStoreNames.ScriveSignerRoleManagement, getArenaSignSignerRoleManagementState);
    StickySettingsStore.registerStore(StickyStoreNames.ScriveTemplateManagement, getArenaSignTemplateManagementState);
    StickySettingsStore.registerStore(StickyStoreNames.ListMaintenance, getListMaintenanceState);
  }
};
